module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-stone-path-background.e3fbdc58.png";